module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.e31fcf1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.ttf
// module id = 309
// module chunks = 1